import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  const handleServiceClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById('service-pricing');
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  const otherServices = [
    {
      title: 'Servis vidlic a tlumičů',
      logos: [
        { 
          name: 'Fox', 
          image: '/Fox-Racing-Logo.png',
          url: 'https://www.ridefox.com'
        },
        { 
          name: 'RockShox', 
          image: '/rockshox-logo-png_seeklogo-282052.png',
          url: 'https://www.sram.com/en/rockshox'
        }
      ],
      description: 'Servis a opravy odpružených jednotek značek Fox a RockShox. Kompletní servis včetně výměny oleje, těsnění a seřízení. Kalibrace kluzných pouzder spodních nohou vidlice.'
    },
    {
      title: 'Servis<br />elektrokol',
      description: 'Specializovaný servis a opravy elektrokol všech značek.'
    },
    {
      title: 'Lakování<br />rámů',
      description: 'Lakování rámů jízdních kol v různých barvách a stylech.'
    },
    {
      title: 'Kola<br />na zakázku',
      description: 'Stavba kol na zakázku podle vašich požadavků a preferencí.'
    },
    {
      title: 'Předsezónní<br />prohlídky',
      description: 'Komplexní kontrola a příprava kola na novou sezónu.'
    }
  ];


  return (
    <section className="services" id="services">
      <div className="services-container">
        <h2 className="section-title">Služby</h2>
        
        <div className="services-grid">
          <div 
            className="service-card service-card-link"
            onClick={handleServiceClick}
          >
            <div className="service-card-title">
              <h3>Servis</h3>
              <p className="service-subtitle">
                Malý a velký servis veškerých jízdních kol.
              </p>
            </div>
          </div>

          {otherServices.map((service, index) => (
            <div key={index} className="service-card">
              <h3 dangerouslySetInnerHTML={{ __html: service.title }}></h3>
              <p>{service.description}</p>
              {service.logos && (
                <div className="service-logos">
                  {service.logos.map((logo, logoIndex) => (
                    <div key={logoIndex} className="service-logo">
                      {logo.url ? (
                        <a href={logo.url} target="_blank" rel="noopener noreferrer" className="service-logo-link">
                          {logo.image ? (
                            <img src={logo.image} alt={logo.name} className="service-logo-img" />
                          ) : (
                            <span className="service-logo-text">{logo.name}</span>
                          )}
                        </a>
                      ) : (
                        <>
                          {logo.image ? (
                            <img src={logo.image} alt={logo.name} className="service-logo-img" />
                          ) : (
                            <span className="service-logo-text">{logo.name}</span>
                          )}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

